import styled from "styled-components";
import { colours } from "../../../../../../styles/colours.constants";
import { satoshi500 } from "../../../../../../styles/font.constants";

export const Wrapper = styled.div`
	margin-bottom: 1rem;
`;

export const UpdatesTextarea = styled.textarea`
	width: 100%;
	border-radius: 0.5rem;
	border-width: 2px;
	border-color: ${colours.greyDark};
	padding: 0.8rem;
	color: ${colours.black}D9;
	font-size: 1.1rem;
	${satoshi500}
	letter-spacing: 4%;
	line-height: 150%;
	outline: none;
	resize: none;
	&::placeholder {
		color: ${colours.black}60;
	}
`;
